import stylesheet from './SocialLink.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import '../icon/icon';

class NXTSocialLink extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get icon(): string {
        return this.getAttribute('icon') ?? '';
    }

    get href(): string {
        return this.getAttribute('href') ?? '#';
    }

    get label(): string {
        return this.getAttribute('label') ?? '';
    }

    render() {
        const link = document.createElement('a');
        link.classList.add('social-link');
        link.setAttribute('href', this.href);
        if (this.label) link.setAttribute('aria-label', this.label);
        for (const attr of ['target', 'rel']) {
            const value = this.getAttribute(attr);
            if (value) link.setAttribute(attr, value);
        }

        const icon = document.createElement('nxt-icon');
        icon.setAttribute('icon', this.icon);
        link.appendChild(icon);

        return link;
    }
}

customElements.define('nxt-social-link', NXTSocialLink);
